module.exports = __webpack_public_path__ + "img/skogbruk_smvf.28435582.jpg";